import React from 'react';

// render all parameters selected(customer or bestPrice) on hidden fields
export default (props) => {
  const list = Object.keys(props.parameters).map((name) => {
    const value = props.parameters[name];
    if (name === 'quantities')
      return null;

    return (<input type="hidden" name={`parameters[${name}]`} key={name} value={value} />);
  })

  return (
    <div id="hidden-fabrication-parameters">
      {list}
    </div>
  );
};
